import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { TAB_ROOTS } from "@/shared/config";
import { closeTopOverlay } from "@/shared/ui";

import { hideBackButton, onBackButtonClick, showBackButton } from "./sdk";

/**
 * Нативная кнопка «назад» Telegram. На корнях вкладок скрыта: уходить из корня
 * некуда, а показанная кнопка выбросила бы пользователя из приложения.
 */
export function useTelegramBackButton(): void {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isTabRoot = TAB_ROOTS.includes(pathname);

  useEffect(() => {
    if (isTabRoot) {
      hideBackButton();
      return;
    }

    showBackButton();
    const off = onBackButtonClick(() => {
      // Открытый шит или модалку кнопка «назад» должна закрывать, а не уводить
      // с экрана: иначе пользователь, закрывая фильтры, вылетает из каталога.
      if (closeTopOverlay()) return;
      void navigate(-1);
    });

    return () => {
      off();
      hideBackButton();
    };
  }, [isTabRoot, navigate]);
}
